

export enum LineType {
    Solid,
    Dash,
}
